import axios from 'axios';
import { config } from "@/config/config.js";
import router from '@/router';


const instance = axios.create({
  baseURL: config.queryLambdaURL,

});

/**
 * Matches path params ../:callType/:botName
 * @param url
 * @returns {{botName: *, callType: *}|null}
 */
function parseUrl(url) {
  const pattern = /\/(\w+)\/(\w+)$/;
  const match = url.match(pattern);
  if (match) {
    return {
      callType: match[1],
      botName: match[2]
    };
  } else {
    return {};
  }
}

// Request interceptor
instance.interceptors.request.use(function (requestConfig) {
  if (requestConfig.baseURL) {
    const params = parseUrl(requestConfig.url);
    let token = config.queryLambdaToken
    let jwt = localStorage.getItem("jwt-"+params.botName)
    if (jwt) {
      token = jwt
    }
    requestConfig.headers.Authorization = `Bearer ${token}`;
  }
  return requestConfig;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Response interceptor
instance.interceptors.response.use(function (response) {
  // Any status code within the range of 2xx cause this function to trigger
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  const params = parseUrl(error.response.config.url)
  //Check for 401 error (unauthorized, and have them log in again).
  if (error.response && error.response.status === 401){
    //Clear the jwt and go to the main page
    console.log("401 Unauthorized ", error, params)

    if(localStorage.getItem("jwt-"+params.botName)){
      console.log("Removing jwt and trying again with normal bearer token", params.botName)
      localStorage.removeItem("jwt-"+params.botName);
      return axios.request(error.config);
    }

    console.log("Going to login screen again")
    router.push({path:'/login',query:{botName:params.botName, streaming:false}});
  }else if(error.response && error.response.status === 403){
    console.log("403 Forbidden", error)
    router.push('/unauthorized');
  }
  return Promise.reject(error);
});

export default instance;
